export const assetPrefix = '[JokerBonus]'
export enum assetNames {
	bannerLogo = 'Joker Bonus progressive',
	bannerLogoBel = 'Joker Jackpot progressive',
	bannerLogoHead = 'Joker Bonus head',
	winAnimSmoke = 'bonus_smoke_start',
	winAnimJoker = 'Joker_appear_mobile',
	winAnimCard = 'card_rotation',
	winAnimCardTrail = 'card_smoke_tail',
	winAnimLogo = 'Joker Bonus',
	winAnimLogoBel = 'Joker Jackpot',
	winAnimCoin = 'coin_gold',
	winAnimFirework = 'fireworks',
}
export const fileNames = {
	card: ['Card-rotation'],
	cardSmoke: ['Card-smoke-0', 'Card-smoke-1', 'Card-smoke-2'],
	coins: ['coins'],
	fireworks: ['fireworks'],
	jokerSmoke: ['WinAnim-smoke-0', 'WinAnim-smoke-1', 'WinAnim-smoke-2'],
} as const
export const fileNamesSpine = {
	win: ['spine/JB-win'],
} as const
